import ArrowForward from '@mui/icons-material/ArrowForward';
import { Button } from '@mui/material';
import React, { FC } from 'react';

interface IProps {
	children: React.ReactNode;
	onClick?: () => void;
	type?: 'submit';
	disabled?: boolean;
}

const ContinueButton: FC<IProps> = ({ onClick, children, type, disabled }) => {
	return (
		<Button
			variant='contained'
			size='large'
			type={type}
			color='secondary'
			onClick={onClick}
			disabled={disabled}
			sx={(theme) => ({
				height: '48px',
				float: 'right',
				marginLeft: 'auto',
				minWidth: '200px',
				maxWidth: '200px',
				textWrap: 'nowrap',
				[theme.breakpoints.down('md')]: {
					minWidth: 'initial',
					maxWidth: 'unset',
				},
			})}
			endIcon={<ArrowForward />}
		>
			{children}
		</Button>
	);
};

export default ContinueButton;
